import { Order } from '@api/types';
import { StatusLight } from '@components';
import { longDate } from '@utils/date.utils';

export const getOrderItems = (order: Order, orderType: string, orderStatus: string) => [
  { fieldName: 'orderId', fieldValue: order.vismaOrderNumber },
  { fieldName: 'dealerOrderId', fieldValue: order.dealerOrderId },
  { fieldName: 'customerNo', fieldValue: order.customerNo },
  { fieldName: 'customerName', fieldValue: order.customerName },
  {
    fieldName: 'status',
    component: <StatusLight status={order.erpStatus}>{orderStatus}</StatusLight>,
  },
  { fieldName: 'orderType', fieldValue: orderType },
  { fieldName: 'deliveryDate', fieldValue: order.deliveryDate },
  { fieldName: 'createdOn', fieldValue: longDate(order.createdOn) },
  { fieldName: 'createdBy', fieldValue: order.createdBy },
  { fieldName: 'deliveryTo', fieldValue: order.deliveryTo },
  { fieldName: 'comment', fieldValue: order.comment },
  { fieldName: 'traceId', fieldValue: order.traceID },
];
